import {Component, OnInit} from '@angular/core';
import {environment} from "../../../environments/environment";
import {NotificationService} from "../../services/notification/notification.service";
import { ConfigurationService } from 'src/app/services/configuration.service';


@Component({
  selector: 'app-gestion-salaries',
  templateUrl: './gestion-salaries.component.html',
  styleUrls: ['./gestion-salaries.component.scss'],

})
export class GestionSalariesComponent implements OnInit {

  configuration = this.configurationService.get();
  public fileNamePattern = new RegExp(this.configurationService.get().global.fileNamePattern);
  constructor(protected notificationService: NotificationService, private configurationService: ConfigurationService) {
  }

  ngOnInit(): void {
  }

  handleOnAddViaDsnEvent(_event: any) {
    const count: number = this.notificationService.countDsnNotificationSubject.getValue();
    if (_event && count > 0) {
      this.notificationService.countDsnNotificationSubject.next(count - 1);
    }
  }
}
